import { z } from "zod"

export const WebExtractionResponseDataSchema = z.discriminatedUnion("status", [
  z.object({ id: z.string(), status: z.literal("queued") }),
  z.object({ id: z.string(), status: z.literal("running") }),
  z.object({ id: z.string(), status: z.literal("completed"), markdown: z.string() }),
  z.object({ id: z.string(), status: z.literal("failed"), error: z.string() }),
])
